/*
 * SHLightProbe constants - extracted to break circular dependency
 * between SHLightProbe.js and SHLightProbeVisualizer.js
 */

export enum LightProbeVisualizationMode {
  None = -1,
  Irradiance = 0,
  IrradianceSH = 1,
  Radiance = 2,
  SkipRender = 3,
  PMREM = 4,
}
